import TextField, { TextFieldProps } from '@mui/material/TextField';
import { ChangeEvent } from 'react';
import { Control, Controller, FieldError } from 'react-hook-form';

type FormNumberInputProps = {
  name: string;
  control: Control;
  label: string;
  rules?: object;
  error?: FieldError;
  onNumberChange?: (number: number | undefined) => void;
  margin?: TextFieldProps['margin'];
  size?: TextFieldProps['size'];
} & TextFieldProps;

const FormNumberInput = ({
  name,
  control,
  label,
  rules,
  error,
  margin = 'normal',
  size = 'medium',
  onNumberChange,
  sx,
  ...props
}: FormNumberInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue=""
      render={({ field }) => (
        <TextField
          sx={{ flex: '1', ...sx }}
          label={label}
          margin={margin}
          size={size}
          {...field}
          {...props}
          type="number"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            const number = e.target.value === '' ? null : Number(e.target.value);
            onNumberChange?.(number);
            field.onChange(number);
          }}
          error={!!error}
          helperText={error?.message}
        />
      )}
    />
  );
};

export default FormNumberInput;
